import { useQueryClient } from '@tanstack/react-query';
import React, { FC, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CurrencyInput } from '@eika/currency-input';

import { LaantypeWeb, SoeknadLaanContainerWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { LaanebeloepFormData } from './laanebeloep';

const FlytteGjeld: FC = () => {
    const { boligVerdi, validationMessage } = useTranslation();
    const {
        watch,
        control,
        formState: { errors },
    } = useFormContext<LaanebeloepFormData>();
    const { eksisterendeLaanebeloep } = watch();
    const queryClient = useQueryClient();

    useEffect(() => {
        if (eksisterendeLaanebeloep) {
            const soeknadLaanContainer: SoeknadLaanContainerWeb | undefined = queryClient.getQueryData(['soeknadLaan']);
            if (soeknadLaanContainer) {
                soeknadLaanContainer.laan.eksisterendeLaanebeloep = eksisterendeLaanebeloep;
                soeknadLaanContainer.laan.laantype = LaantypeWeb.UTLAAN;
                queryClient.setQueryData(['soeknadLaan'], soeknadLaanContainer);
            }
        }
    }, [eksisterendeLaanebeloep, queryClient]);

    return (
        <Controller
            control={control}
            name="eksisterendeLaanebeloep"
            rules={{
                required: `${validationMessage.requiredValue}`,
            }}
            render={({ field: { onChange, value } }) => (
                <CurrencyInput
                    name="eksisterendeLaanebeloep"
                    label={boligVerdi.labelRestgjeld}
                    className="max-width-200"
                    placeholder=""
                    type="tel"
                    error={errors.eksisterendeLaanebeloep?.message}
                    value={value}
                    onValueChange={(v) => onChange(v.value)}
                />
            )}
        />
    );
};

export default FlytteGjeld;
